import { z } from 'zod';

const defaultFormat = (date: string) => {
  const [day, month, year] = date.split('/');
  return new Date(`${year}/${month}/${day}`);
};

const isDateInvalid = (dateString: string, dateObject: Date) => {
  const [day] = dateString.split('/');

  return parseInt(day, 10) !== dateObject.getDate();
};

type DateValidatorOptions = {
  minDate?: Date;
  maxDate?: Date;
  format?: (value: string) => Date;
  isFullDate?: boolean;
  messages?: Partial<{
    required: string;
    format: string;
    invalid: string;
    min: string;
    max: string;
  }>;
};

const dateValidator = ({ minDate, maxDate, format, isFullDate, messages }: DateValidatorOptions = {}) => {
  return (value: string, ctx: z.RefinementCtx) => {
    if (!value) {
      ctx.addIssue({
        code: 'custom',
        message: messages?.required || 'A data é obrigatória',
      });
      return;
    }

    if (isFullDate && value.length !== 10) {
      ctx.addIssue({
        code: 'custom',
        message: messages?.format || 'A data está incompleta',
      });
      return;
    }

    const dateValue = format ? format(value) : defaultFormat(value);

    if (isNaN(dateValue.getTime())) {
      ctx.addIssue({
        code: 'custom',
        message: messages?.invalid || 'A data está inválida',
      });
      return;
    }

    if (isFullDate && isDateInvalid(value, dateValue)) {
      ctx.addIssue({
        code: 'custom',
        message: messages?.invalid || 'A data está inválida',
      });
      return;
    }

    if (minDate && dateValue.getTime() < minDate.setHours(0, 0, 0, 0)) {
      ctx.addIssue({
        code: 'custom',
        message: messages?.min || 'A data está inválida',
      });
      return;
    }

    if (maxDate && dateValue.getTime() > maxDate.getTime()) {
      ctx.addIssue({
        code: 'custom',
        message: messages?.max || 'A data está inválida',
      });
    }
  };
};

export default dateValidator;
